import { createGlobalStyle } from 'styled-components';

/** @type {import('./theme.types').CustomTheme} */
const myTheme = {
  listsBorder: 'solid 1px #EAE9E9',
  gray: 'rgba(0, 0, 0, 0.65)',
  gray1: '#333',
  lightGray: 'rgba(0, 0, 0, 0.25)',
  green2: '#2f7a5c',
  green3: '#35b281',
  green4: '#26805c',
  green5: '#28664D',
  newGreen: '#2f943e',
  lightGreen: '#35b281',
  primaryColor: '#5556FF', //making the primary color explicit
  buttonPurple: '#975C8A',
  newPurple: '#7e4b72',
  buttonGreen: '#4FCB9A',
  pastelYellow: '#fdec96',
  buttonRed: '#ff5345',
  iconColor: '#5556FF',
  fontColor: '#51555c',
  newOrange: '#ec4414',
  lightBlueGray: '#d4d7d9',
  blueGrayColor: '#a0a4ab',
  darkBlueGrayTwo: '#233456',
  basicsError: '#F5222D',
  basicsWarning: '#faad14',
  shoreCiBlue: '#0099ff',
  fontFamily: 'Roboto, PingFang SC, "Segoe UI Emoji", Segoe UI Symbol',
  fontVariant: 'tabular-nums',
  colorError: '#F5222D',
  colorErrorBg: '#FFF1F0',
  colorSuccess: '#52C41A',
  colorSuccessBg: '#F6FFED',
  colorWarning: '#FAAD14',
  colorWarningBg: '#FFFBE6',
};

// mostly used to fix global layout breaks after upgrading antd to v4
export const GlobalStyle = createGlobalStyle`
body{
  margin:0;
  font-family: "Roboto, PingFang SC, 'Segoe UI Emoji', Segoe UI Symbol";
}

.ant-tabs-content-holder,
.ant-tabs-tabpane,
.ant-tabs-content {
  background: transparent !important;
  background-color: transparent !important;
}
  .ant-tag-warning{
  color: #fa8c16 !important;
  border-color: #ffd591 !important;
  }
  .ant-menu-item{
  padding-left: 24px !important;
    margin-bottom: 8px !important;
    margin-top: 4px !important;
    padding-right: 16px !important;
    }
  #hubspot-messages-iframe-container {
    z-index: 500 !important;
  }

  .ant-form-item-explain {
    margin-top: 0;
  }

  .prod_type_select .ant-select-item-option-content {
    white-space: unset;
  }

  .ant-btn > .ant-btn-loading-icon {
      margin-right: 5px;
  }

  .checkout-success-modal{
   .ant-modal-confirm .ant-modal-body {
     padding: 0px !important;
   }
     .ant-modal-confirm-body{
     border-bottom: 1px solid rgba(0,0,0,.06) !important;
     padding-bottom: 5px;
     }

   .ant-modal-body {
     padding: 15px !important;
    }

    .ant-modal-confirm .ant-modal-confirm-btns{
      margin-top: 0px !important;
      border-top: 1px solid rgba(0,0,0,.06) !important;
    }
      .ant-modal-confirm-btns{
       margin-top: 5px !important;
      }
}
     .ant-alert{
     border-radius: 0px !important;
     }

     .ant-modal-container{
       padding: 0 !important;
       }
 .ant-modal-content{
       border-top: 1px solid rgba(0,0,0,.06) !important;
       margin: 0 auto !important;
       padding: 0px !important;
       border-radius: 0px !important;
    }
       .ant-modal-header{
       padding: 20px !important;
       border-bottom: 2px solid #f0f0f0 !important;
       }

       .ant-modal-footer{
       padding:10px  !important;
       border-top: 2px solid #f0f0f0 !important;
       }
       .ant-table-row-level-1 > td[class*='ant-table-cell']{
          background: #FAFAFA !important;
       }

       .ant-modal-confirm-body-wrapper{
       padding: 24px !important;

          .ant-modal-confirm-btns .ant-btn-primary {
          background: #5556FF !important;
        }

       }     
`;

export default myTheme;

/** @type {import('antd/lib').ThemeConfig} */
export const antdTheme = {
  token: {
    colorPrimary: '#5556FF',
    colorPrimaryHover: '#5556FF',
    colorPrimaryActive: '#5556FF',
    colorPrimaryBorder: '#B3B3FF',
    colorPrimaryBg: '#EEEEFF',
    colorSuccess: '#52C41A',
    colorSuccessBorder: '#B7EB8F',
    colorSuccessBg: '#F6FFED',
    colorWarning: '#FAAD14',
    colorWarningBorder: '#FFE58F',
    colorWarningBg: '#FFFBE6',
    colorError: '#F5222D',
    colorErrorBorder: '#FFA39E',
    colorErrorBg: '#FFF1F0',
    fontFamily: 'Roboto, PingFang SC, Segoe UI Emoji, Segoe UI Symbol',
    layoutHeaderBackground: '#233456',
    menuItemHeight: '48px',
    menuInlineToplevelItemHeight: '48px',
    alertInfoBgColor: '#e6f7ff',
    alertInfoBorderColor: '#91d5ff',
    alertInfoIconColor: '#1890f0',
    inputBg: '#ffffff',
    formItemMarginBottom: '0px',
    colorLink: '#5556FF',
    headerBorderBottom: '1px solid #f0f0f0',
  },
};
